export const LARGE_BREAKPOINT = 1200;
export const MAX_BREAKPOINT = 1920;
